export default {
    columnList: {
        buttonTitle: 'Выбор колонок списка',
        okTitle: 'Сохранить',
        cancelTitle: 'Отмена',
        modalTitle: 'Выберите необходимые колонки',
    },

    eventFilter: {
        orderId: 'Номер заказа',
        eventHandlersPlaceholder: 'Типы событий',
        eventHandlersText: 'Выбрано типов событий',
        dateCreate: 'Дата создания',
        buttonClear: 'Очистить фильтр',
    },

    filter: {
        id: 'Номер заказа',

        orderSourceTypes: {
            placeholder: 'Источник заказа',
            text: 'Выбрано источников заказа',
        },

        timeWaitingFrom: 'Срок ожидания: от',
        timeWaitingTo: 'Срок ожидания: до',
        buttonClear: 'Очистить фильтр',
        buttonClearSearch: 'Очистить поиск',
        search: 'ФИО или номер телефона клиента',
        dateCreateFrom: 'Дата создания: от',
        dateCreateTo: 'Дата создания: до',

        statuses: {
            placeholder: 'Статус обработки',
            text: 'Выбрано статусов',
        },

        userAuthorization: {
            placeholder: 'Статус пользователя',
            text: 'Выбрано статусов пользователя',
        },

        pfm: 'Код магазина ПФМ',
        city: 'Населенный пункт',
        address: 'Адрес магазина',
        partnerOrderId: '№ заказа партнера',
        formSelectOption: 'Тестовый заказ',

        managers: {
            placeholder: 'Менеджер',
            text: 'Выбрано менеджеров',
        },

        deliveryStatuses: {
            placeholder: 'Статус доставки',
            text: 'Выбрано статусов доставки',
        },

        payTypes: {
            placeholder: 'Тип оплаты',
            text: 'Выбрано типов оплаты',
        },

        payStatuses: {
            placeholder: 'Статус оплаты',
            text: 'Выбрано статусов оплаты',
        },

        deliveryServiceTypes: {
            placeholder: 'Тип доставки',
            text: 'Выбрано типов доставки',
        },

        orderTypes: {
            placeholder: 'Тип заказа',
            text: 'Выбрано типов заказа',
        },

        deliveryServiceMethods: {
            placeholder: 'Метод доставки',
            text: 'Выбрано методов доставки',
        },

        testValues: {
            value1: 'Нет',
            value2: 'Да',
        },

        userAuthorizationOptions: {
            value1: 'Авторизован',
            value2: 'Не авторизован',
        },
    },

    productFilter: {
        input: 'Поиск',
        checkbox: ['ЛК', 'Штрихкод'],
    },
};